import type { WidgetPreviewConfig } from './types';
import { WidgetAvatar } from './widget-avatar';
import styles from './widget-preview.module.scss';

interface WidgetTriggerProps {
  config: WidgetPreviewConfig;
  onOpen: () => void;
}

export const WidgetTrigger = ({ config, onOpen }: WidgetTriggerProps) => (
  <button
    type="button"
    className={styles.trigger}
    style={{
      height: config.trigger.heightPx,
      borderRadius: config.trigger.borderRadius,
    }}
    onClick={onOpen}
  >
    <WidgetAvatar appearance={config.appearance} size={28} className={styles.triggerAvatar} />
    <span>{config.content.buttonText}</span>
  </button>
);
